<template>
  <div class="mainChild page-content" id="lowPriceDetails">
    <div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>智慧服务</el-breadcrumb-item>
        <el-breadcrumb-item>品牌商品分析</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="headerBrand">
      <section class="seaerch-wrapper">
        <el-tabs v-model="activeName" style="margin-bottom: 20px;">
          <el-tab-pane label="禅妈妈" name="first"></el-tab-pane>
        </el-tabs>
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="商品标题" :label-width="formLabelWidth">
            <el-input clearable placeholder="请输入商品标题" v-model="list.title" size="small"></el-input>
          </el-form-item>
          <el-form-item label="品牌名称" :label-width="formLabelWidth">
            <el-input :clearable="true" placeholder="请输入品牌名称" v-model="list.brandname" size="small"></el-input>
          </el-form-item>
          <el-form-item label="店铺名称" :label-width="formLabelWidth">
            <el-input :clearable="true" placeholder="请输入店铺名称" v-model="list.shopname" size="small"></el-input>
          </el-form-item>
          <el-form-item label="日期" :label-width="formLabelWidth">
            <el-date-picker
              v-model="searchformDate"
              type="daterange"
              start-placeholder="请选择"
              end-placeholder="请选择"
              range-separator="~"
              :picker-options="pickerOptions"
              size="small"
            ></el-date-picker>
          </el-form-item>
          <el-form-item style="margin-top: 4px;">
            <el-button size="small" class="search-btn" @click="getIprPluginListList(1)">查  询</el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>
    <div class="downContainer">
      <div class="downBtn">
        <el-button size="small" type="primary" @click="updata">更新数据</el-button>
        <el-button size="small" @click="newDow">下载数据</el-button>
        <el-button size="small" @click="onOpenDeleteDia()">批量删除</el-button>
      </div>
      <div class="prompt">
        <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
        共<span class="promptFont">{{total}}</span>项,已选择<span class="promptFont">{{openNumber}}</span>项
        <span class="promptFont2" @click="toggleSelection([tableData])">勾选全部</span>
        <span class="promptFont">/</span>
        <span class="promptFont2" @click="toggleSelection()">取消勾选</span>
      </div>
      <!-- <div class="prompt">
        <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
          共<span class="promptFont">{{total}}</span>项
      </div> -->
      <!--表格-->
      <el-table
        ref="multipleTable"
        :data="tableList"
        style="width: 100%"
        v-loading="tableLoading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" fixed="left">
        </el-table-column>
        <el-table-column label="序号" align="left" width="50">
          <template slot-scope="scope">
            {{scope.$index | indexMethod(list.pageNo,list.pageSize)}}
          </template>
        </el-table-column>
        <el-table-column label="标题" prop="title">
          <template slot-scope="scope">
            <el-link type="primary" :href="scope.row.link" target="_blank" :underline="false">{{scope.row.title}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格">
        </el-table-column>
        <el-table-column prop="minprice" label="最低价格">
        </el-table-column>
        <el-table-column prop="shopname" label="店铺">
        </el-table-column>
        <el-table-column prop="sales" label="预估总销售额">
        </el-table-column>
        <el-table-column prop="totalsales" label="预估总销量">
        </el-table-column>

        <el-table-column prop="anchor" label="主播">
        </el-table-column>
        <el-table-column prop="linkstatus" label="状态">
        </el-table-column>
        <el-table-column label="数据更新时间" width="200px">
          <template slot-scope="scope">
            <span v-show="scope.row.updatetime">{{scope.row.updatetime | fullTime}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="brandname" label="品牌名称">
        </el-table-column>
      </el-table>
      <!--下载数据-->
      <el-dialog
        title="下载数据"
        :visible.sync="markingShow"
        width="360px"
        height="278"
        size="small"
      >
        <div class="yellowStyle">
          <img src="../../assets/img/other/trumpet_icon.png" style="margin-right: 5px;">
          <span>
            设置execl表名。
          </span>
        </div>
        <el-form class="search-form">
          <el-form-item label="品牌名称：" :label-width="formLabelWidth" :required="true">
            <el-input :clearable="true" placeholder="请输入品牌名称" v-model="nameEx" size="small" style="width: 220px;" :maxlength="16"></el-input>
            <div style="color: #ccc;">
              名称请保持在16个字以内
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="downTable" :loading="lowPriceLoading" type="primary">确 定</el-button>
          <el-button @click="markingShow = false" size="small" type="cancel_blue">取 消</el-button>
        </span>
      </el-dialog>
      <!--更新数据-->
      <el-dialog
        title="更新设置"
        :visible.sync="updataShow"
        width="580px"
        height="278"
        size="small"
      >
        <el-form class="search-form">
          <el-form-item label="品牌名称：" :label-width="formLabelWidth" :required="true">
            <el-input :clearable="true" placeholder="请输入" v-model="brandname" size="small" style="width: 400px;"></el-input>
          </el-form-item>
          <el-form-item label="品牌ID：" :label-width="formLabelWidth" :required="true">
            <div style="width: 440px;">
              <el-input :clearable="true" placeholder="请输入" v-model="brandid" size="small" style="width: 400px;"></el-input>
              <el-button type="text" style="float: right;" @click="jump(1)">样式</el-button>
            </div>
          </el-form-item>
          <el-form-item label="页码：" :label-width="formLabelWidth" :required="true">
            <div style="width: 440px;">
              <el-input :clearable="true" placeholder="请输入" v-model="pagenum" size="small" style="width: 400px;"></el-input>
              <el-button type="text" style="float: right;" @click="jump(2)">样式</el-button>
            </div>
          </el-form-item>
          <el-form-item label="Cookie：" :label-width="formLabelWidth" :required="true">
            <el-input :clearable="true" placeholder="请输入" v-model="cookie" size="small" style="width: 400px;"></el-input>
          </el-form-item>
          <el-form-item label="选择日期：" :label-width="formLabelWidth" :required="true">
            <el-radio v-model="daynum" label="7">近7天</el-radio>
            <el-radio v-model="daynum" label="15">近15天</el-radio>
            <el-radio v-model="daynum" label="30">近30天</el-radio>
          </el-form-item>
        </el-form>
        <div class="yellowStyle">
          <img src="../../assets/img/other/trumpet_icon.png" style="margin-right: 5px;">
          <span>
            点击确定以后，请浏览网页，如果遇到了验证，请及时划过验证模块，否则则会更新失败。
          </span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="saveBrandAnalysis" :loading="saveLoading" type="primary">确 定</el-button>
          <el-button @click="updataShow = false" size="small" type="cancel_blue">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 删除 -->
      <el-dialog
        title="提示"
        :visible.sync="deleteShow"
        width="360px" style="margin-top: 10%;" id="dialog">
        <div style="display: flex;width: 100%;justify-content:center;">
          <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
          <div>
            <div style="font-size: 16px;">
              你确认要删除<span>{{delType}}</span>信息吗？
            </div>
            <div style="font-size: 14px;">删除后
              <span style="color: #e90e24;font-size: 14px;">
                信息将会被彻底删除
              </span>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="deleteReview" size="small" :loading="ficationLoading">确 定</el-button>
          <el-button @click="delCancel" size="small" type="TheCustom">取 消</el-button>
        </span>
      </el-dialog>
      <!--分页-->
      <pagination
        v-if="tableList&&tableList.length>0"
        :currentPage="currentPage"
        :pageSizes="[10, 20, 50, 100]"
        :total="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </div>
  </div>
</template>
<script>
import pagination from "../../components/dataTable/pagination";
export default {
  name: "brandAnalysis",
  data() {
    return {
      saveLoading: false,
      markingShow: false,
      nameEx: '',
      activeName: 'first',
      bulLoading: false,
      BulkImportShow: false,
      searchformDate: [],
      pickerOptions: {
        shortcuts: [{
          text: '今日',
          onClick:(picker) => {
            this.getRecentDate(picker,1);
          }
        },{
          text: '近7日',
          onClick:(picker) => {
            this.getRecentDate(picker,7);
          }
        }, {
          text: '近15日',
          onClick:(picker) => {
            this.getRecentDate(picker,15);
          }
        }, {
          text: '近30日',
          onClick:(picker) => {
            this.getRecentDate(picker,30);
          }
        }, {
          text: '近90日',
          onClick:(picker) => {
            this.getRecentDate(picker,90);
          }
        }, {
          text: '近365日',
          onClick:(picker) => {
            this.getRecentDate(picker,365);
          }
        }]
      },
      lowPriceLoading: false,
      pageNo: 1,
      pageSize: 10,
      tableLoading: false,
      formLabelWidth: "100px",
      tableList: [],
      currentPage: 1,
      total: "",
      list: {
        pageNo: 1,
        pageSize: 10,
        platform: '',
        title: "",
        shopname: "",
        brandname: "",
      },
      updataShow: false,
      daynum: '7',
      bmcid: '',
      brandid: '',
      brandname: '',
      cookie: '',
      fatherId: '',
      pagenum: '',
      status: '',
      checkAll: 0,
      openNumber: 0,
      deleteShow: false,
      delType: '',
      ficationLoading: false,
    };
  },
  components: {
    pagination
  },
  mounted() {
    this.getByBrandAnalysis();
  },
  methods: {
    // 序号勾选
    handleSelectionChange(val) {
      if (this.checkAll != 2) {
        this.openNumber = val.length;
        this.selectRows = val;
      }
    },
    // 确认删除
    deleteReview() {
      this.ficationLoading = true
      let params = {}
      if (this.searchformDate) {
        if (this.searchformDate[0] && this.searchformDate[1]) {
          params.starttime = this.$options.filters["fullTime"](
            this.searchformDate[0]
          ).substring(0, 10) + " 00:00:00";
          params.endtime = this.$options.filters["fullTime"](
            this.searchformDate[1]
          ).substring(0, 10) + " 23:59:59";
        }
      }
      if (this.list.title) {
        params.title = this.list.title;
      }
      if (this.list.shopname) {
        params.shopname = this.list.shopname;
      }
      if (this.list.brandname) {
        params.brandname = this.list.brandname;
      }
      params.ids = this.delIds
      if (this.delIds != 'checkAll') {
        params.syncdates = this.syncdates
      }
      fetch({
        url: "hcm/hcmBrandAnalysis/deleteBrandAnalysdate",
        method: "post",
        data: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.ficationLoading = false
          this.deleteShow = false
          this.$message({
            message: '成功',
            type: 'success'
          });
          this.openNumber = 0
          this.total = 0
          this.getByBrandAnalysis();
        } else {
          this.ficationLoading = false
          this.$message.error(res.message);
        }
      })
    },
    // 取消删除
    delCancel() {
      this.deleteShow = false
      this.delType = ''
      this.checkAll = ''
      this.delIds = ''
    },
    // 勾选
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleAllSelection(row);
          this.openNumber = this.total
          this.checkAll = 2
        });
      } else {
        this.$refs.multipleTable.clearSelection();
        this.checkAll = 1
        this.openNumber = 0
      }
    },
    // 删除/整改形式
    onOpenDeleteDia(e) {
      console.log(this.selectRows)
      this.delIds = ''
      if (this.checkAll == 2) {
        this.delType = '全部'
        this.delIds = "checkAll"
      } else {
        this.delType = this.openNumber + '条'
        let arrIds = []
        for (let i in this.selectRows) {
          arrIds.push(this.selectRows[i].id)
        }
        this.delIds = arrIds.join(',')
      }
      if (this.delIds == '' || this.openNumber == 0) {
        this.$message({
          message: '没有选中项',
          type: 'warning'
        });
        return
      }
      this.deleteShow = true
    },
    jump(e) {
      if (e == 1) {
        window.open('https://hawksights.obs.cn-east-2.myhuaweicloud.com/system/cmm2.png', '_blank');
      } else {
        window.open('https://hawksights.obs.cn-east-2.myhuaweicloud.com/system/cmm1.png', '_blank');
      }
    },
    saveBrandAnalysis() {
      if (!this.brandname) {
        this.$message({
          message: '请填写品牌名称',
          type: 'warning'
        });
        return;
      }
      if (!this.brandid) {
        this.$message({
          message: '请填写品牌ID',
          type: 'warning'
        });
        return;
      }
      if (!this.pagenum) {
        this.$message({
          message: '请填写页码',
          type: 'warning'
        });
        return;
      }
      if (!this.cookie) {
        this.$message({
          message: '请填写Cookie',
          type: 'warning'
        });
        return;
      }
      this.saveLoading = true
      let datas = {
        daynum: this.daynum,
        brandid: this.brandid,
        brandname: this.brandname,
        cookie: this.cookie,
        pagenum: this.pagenum,
      };
      if (this.fatherId) {
        datas.id = this.fatherId
      }
      fetch({
        url: "hcm/hcmBrandAnalysis/saveBrandAnalysis",
        method: "post",
        params: datas,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res;
        if (res.status == "10000") {
          this.saveLoading = false
          this.updataShow = false
          this.autopython(res.data.id)
        } else {
          this.$message.error(res.message);
        }
      });
    },
    autopython(id) {
      let datas = {
        daynum: this.daynum,
        brandid: this.brandid,
        brandname: this.brandname,
        cookie: this.cookie,
        pagenum: this.pagenum,
        id: id,
      };
      fetch({
        url: "hcm/hcmBrandAnalysis/autopython",
        method: "get",
        params: datas,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res;
        if (res.status == "10000") {
          this.saveLoading = false
          this.updataShow = false
        } else {
          this.$message.error(res.message);
        }
      });
    },
    updata() {
      this.updataShow = true
    },
    newDow() {
      this.nameEx = ''
      this.markingShow = true
    },
    getRecentDate(picker,n){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
      if(picker){
        picker.$emit('pick', [start, end]);
      }
      if (n === 1) {
        this.searchformDate[0] = end;
        this.searchformDate[1] = end;
      } else {
        this.searchformDate[0] = start;
        this.searchformDate[1] = end;
      }
    },
    // 下载
    downTable() {
      if (!this.nameEx) {
        this.$message({
          message: '请填写品牌名称',
          type: 'warning'
        });
        return;
      }
      this.lowPriceLoading = true
      let datas = {};
      if (this.searchformDate) {
        if (this.searchformDate[0] && this.searchformDate[1]) {
          datas.starttime = this.$options.filters["fullTime"](
            this.searchformDate[0]
          ).substring(0, 10) + " 00:00:00";
          datas.endtime = this.$options.filters["fullTime"](
            this.searchformDate[1]
          ).substring(0, 10) + " 23:59:59";
        }
      }
      if (this.list.title) {
        datas.title = this.list.title;
      }
      if (this.list.shopname) {
        datas.shopname = this.list.shopname;
      }
      if (this.list.brandname) {
        datas.brandname = this.list.brandname;
      }
      fetch({
        url: "hcm/hcmBrandAnalysis/exportExcelBrandAnalysisdata",
        method: "get",
        params: datas,
        noFormat: true,
        responseType: "blob",
        timeout: 60 * 1000 * 5
      }).then(res => {
        //下载
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", this.nameEx + ".xlsx");
        document.body.appendChild(link);
        link.click();
        this.markingShow = false
        this.lowPriceLoading = false
      });
    },
    // 详情
    getByBrandAnalysis() {
      fetch({
        url: "hcm/hcmBrandAnalysis/getByBrandAnalysis",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res;
        if (res.status == "10000") {
          this.fatherId = res.data.id
          this.daynum = res.data.daynum
          this.brandid = res.data.brandid
          this.brandname = res.data.brandname
          this.cookie = res.data.cookie
          this.pagenum = res.data.pagenum
          this.getIprPluginListList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 查询
    getIprPluginListList(e) {
      this.tableLoading = true
      if (e == 1) {
        this.list.pageNo = 1;
      }
      let datas = {
        pageNo: this.list.pageNo,
        pageSize: this.list.pageSize,
      };
      if (this.searchformDate) {
        if (this.searchformDate[0] && this.searchformDate[1]) {
          datas.starttime = this.$options.filters["fullTime"](
            this.searchformDate[0]
          ).substring(0, 10) + " 00:00:00";
          datas.endtime = this.$options.filters["fullTime"](
            this.searchformDate[1]
          ).substring(0, 10) + " 23:59:59";
        }
      }
      if (this.list.title) {
        datas.title = this.list.title;
      }
      if (this.list.shopname) {
        datas.shopname = this.list.shopname;
      }
      if (this.list.brandname) {
        datas.brandname = this.list.brandname;
      }
      fetch({
        url: "hcm/hcmBrandAnalysis/getListBrandAnalysis",
        method: "get",
        params: datas,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res;
        if (res.status == "10000") {
          this.tableLoading = false
          this.tableList = data.content;
          this.total = data.totalElements;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //每页
    handleSizeChange(val) {
      this.list.pageSize = val;
      this.getIprPluginListList();
    },
    //当前页
    handleCurrentChange(val) {
      this.list.pageNo = val;
      this.getIprPluginListList();
    },
  }
};
</script>

<style lang="scss">
@import "style/lowPriceDetails.scss";
.yellowStyle {
  padding: 8px;
  background-color: #fdf6ec;
  border-color: #faecd8;
  color: #e6a23c;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  margin-bottom: 16px;
}
</style>
